import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, DocumentExtensionHandling } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-sequence-nucleic-acid',
  templateUrl: './sequence-nucleic-acid.component.html',
  styleUrls: ['./sequence-nucleic-acid.component.scss']
})
export class SequenceNucleicAcidComponent {
  private allowedFileTypes = [ ...DocumentExtensionHandling.MS_WORD_FILE_EXTENSIONS ];
  private acceptedFileTypes = [ ...DocumentExtensionHandling.MS_WORD_ACCEPT_TYPE ];
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { 
            fileName: DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO_NUCLEIC_ACID,
            allowedFileTypes: this.allowedFileTypes,
            fileAcceptTypes: this.acceptedFileTypes
          }
        });
    dialogRef.afterClosed().subscribe();
  }

  get wasFileUploaded(): boolean {
    const fileName = DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO_NUCLEIC_ACID;
    if(!fileName) {
      return false;
    }

    return this.formService.doesCurrentFormHaveAttachmentForSection(fileName);
  }

  get attachments(): AttachmentModel[] {
    const type = DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO_NUCLEIC_ACID;
    
    if(!type) {
      return [];
    }

    return this.formService.allAttachmentsForSection(type);
  }

  get title() {
    if(this.isFormBType) {
      return `Sequence and Structural information, nucleic acid-based substances (MS-Word document)`;
    }

    if(this.isFormDType) {
      return `Nucleic Acids - Oligonucleotides and gene therapies`;
    }

    if(this.isFormFType) {
      return `Nucleic Acid-based substances (e.g., oligonucleotides, gene therapy substances)`;
    }   

    return ``;
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }
  
  get isFormAType(): boolean {
    return 'FormA' === this.formType;
  }

  get isFormBType(): boolean {
    return 'FormB' === this.formType;
  }

  get isFormCType(): boolean {
    return 'FormC' === this.formType;
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }

  get isFormEType(): boolean {
    return 'FormE' === this.formType;
  }

  get isFormFType(): boolean {
    return 'FormF' === this.formType;
  }
}
